import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import store from './store'
import reportWebVitals from './reportWebVitals'
import './index.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import * as serviceWorker from './service.worker.registration'


ReactDOM.render(
    <React.StrictMode>
        <App store={store}/>
    </React.StrictMode>,
    document.getElementById('root') as HTMLElement
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.register({
    onUpdate: (registration: ServiceWorkerRegistration) => {
        store.dispatch({
            type: '@layout/changeUpdateAvailable',
            payload: {
                updateAvailable: true,
                registration
            }
        })
    }
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
